<template>
  <div>
    <div class="contact container">
      <div v-scroll-reveal="{ delay: 0 }">
        <h1>Hello Made People,</h1>
      </div>
      <form class="form" name="contact" method="POST" data-netlify="true">
        <div class="half">
          <div class="input" v-scroll-reveal="{ delay: 0 }">
            <label for="mp-name">My name is</label>
            <input
              type="text"
              id="mp-name"
              autocomplete="off"
              placeholder="Name"
            />
          </div>
          <div class="input" v-scroll-reveal="{ delay: 100 }">
            <label for="mp-company">I work at</label>
            <input
              type="text"
              id="mp-company"
              autocomplete="off"
              placeholder="Company"
            />
          </div>
          <div class="input" v-scroll-reveal="{ delay: 200 }">
            <label for="mp-email">You can reach me at</label>
            <input
              type="email"
              id="mp-email"
              autocomplete="off"
              placeholder="your@email.com"
            />
          </div>
          <p class="op1" v-scroll-reveal="{ delay: 300 }">
            <button type="submit">
              Send →
            </button>
          </p>
        </div>
        <div class="half">
          <div class="input" v-scroll-reveal="{ delay: 300 }">
            <label for="mp-message">Message</label>
            <textarea
              id="mp-message"
              style="min-height:30vh;"
              autocomplete="off"
              placeholder="Type here ..."
            ></textarea>
          </div>
        </div>
      </form>
    </div>
    <Footer />
  </div>
</template>
<script>
import Footer from "@/components/Footer.vue";
export default {
  name: "contact",
  components: {
    Footer
  },
  beforeCreate: function() {
    document.body.classList.remove("invert");
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.contact {
  position: relative;
  z-index: 1;
  overflow: hidden;
  justify-content: left;
  display: flex;
  //min-height:100vh;
  padding-top: 20vh;
  padding-bottom: 0;
  width: 100%;
  h1 {
    //padding-top:10vh;
    @include headline-medium;
  }
  > div {
    width: 40%;
    margin-right: 10%;
  }
  .form {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    width: 40%;
    justify-self: flex-end;
    .half {
      padding-right: 2vw;
    }
    .full {
      width: 100%;
      padding-right: 2vw;
    }
    .input {
      position: relative;
      margin-bottom: 5vh;
      label {
        line-height: 1.8em;
        opacity: 1;
        font-size: 1.1vw;
      }
      input,
      textarea {
        width: 100%;
        background: transparent;
        border: 0;
        font-size: 1.1vw;
        line-height: 1.8em;
        font-weight: 300;
        font-family: inherit;
        letter-spacing: inherit;
        padding: 0.5vw 0;
        outline: none;
        color: white;
        transition: all 0.3s ease-in-out;
        resize: none;
        &::placeholder {
          //opacity: 0;
        }
        &:-webkit-autofill,
        &:-webkit-autofill:hover,
        &:-webkit-autofill:focus,
        &:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 100px $black inset !important;
          -webkit-text-fill-color: white !important;
        }
      }
    }
    button {
      display: inline-block;
      padding: 1rem 2rem;
      margin: 0;
      text-decoration: none;
      background: transparent;
      color: inherit;
      border: 1px solid rgba(white, 0.2);
      font-family: sans-serif;
      font-size: 1.1vw;
      cursor: pointer;
      text-align: center;
      transition: all 250ms ease-in-out, transform 150ms ease;
      -webkit-appearance: none;
      -moz-appearance: none;
    }

    button:hover,
    button:focus {
      border-color: white;
    }
    button:focus {
      outline: none;
      //outline-offset: -4px;
    }
    button:active {
      opacity: 0.6;
    }
  }
}
@media (max-width: $tablet) {
  .contact {
    display: block;
    > div {
      width: 100%;
      margin-right: 0;
      margin-bottom: 50px;
    }
    .form {
      width: 100%;
      .input {
        margin-bottom: 30px;
        label {
          line-height: 1.8em;
          font-size: 16px;
        }
        input,
        textarea {
          font-size: 16px;
          line-height: 1.6em;
          padding: 5px 0;
        }
        textarea {
          height: 150px;
          min-height: none;
        }
      }
      button {
        font-size: 16px;
      }
    }
  }
}
@media (max-width: $mobile) {
  .contact {
    .form {
      .half {
        width: 100%;
        padding-right: 0;
      }
      .full {
        width: 100%;
        padding-right: 0;
      }
    }
  }
}
</style>
